import { useEffect, useState } from 'react';

export function useCountdown(targetMs: number, tickMs = 1000): number {
  const compute = () => Math.max(0, Math.ceil((targetMs - Date.now()) / 1000));
  const [secondsLeft, setSecondsLeft] = useState(compute);

  useEffect(() => {
    setSecondsLeft(compute());
    const id = window.setInterval(() => setSecondsLeft(compute()), tickMs);
    return () => window.clearInterval(id);
  }, [targetMs, tickMs]);

  return secondsLeft;
}

export function formatTimer(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

export function formatStartsIn(seconds: number): string {
  if (seconds >= 3600) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m.toString().padStart(2, '0')}m`;
  }
  return formatTimer(seconds);
}
